import styled from 'styled-components';

export const ColorSample = styled.div`
  margin-top: 5px;
  padding: 5px;
  width: 40px;
  border: 0.5px solid #e2e2e2;
  background-color: ${(props) => props.color};
`;
